export * from './harbor-library.module';
export * from './system/index';
export * from './service.config';
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
